import { useState, useEffect } from 'react';
import {
  createCategoriesProductDetail,
  deleteCategoriesProductDetail,
  updateCategoriesProductDetail,
  findByidPaketDetil
} from '../services/listProductCategoryService';

export const useListProductCategory = () => {

  const [listProductCategory, setListProductCategory] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const addCategoriesProductDetail = async (product) => {
    try {
      const response = await createCategoriesProductDetail(product);
      setListProductCategory([...listProductCategory, response.data]);
    } catch {
      setError('Failed to add product');
    }
  };

  const editCategoriesProductDetail = async (id, updatedProduct) => {
    try {
      const response = await updateCategoriesProductDetail(id, updatedProduct);
      setListProductCategory(listProductCategory.map(p => (p.id === id ? response.data : p)));
    } catch {
      setError('Failed to update product');
    }
  };

  const removeCategoriesProductDetail = async (id) => {
    try {
      await deleteCategoriesProductDetail(id);
      setListProductCategory(listProductCategory.filter(p => p.id !== id));
    } catch {
      setError('Failed to delete product');
    }
  };

  const fetchCategoriesProductDetailByIdPaketDetil = async (id) => {
    setLoading(true);
    try {
      const response = await findByidPaketDetil(id);
      setListProductCategory(response.data);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoriesProductDetailByIdPaketDetil()
  }, []);

  return {
    loading,
    error,
    listProductCategory,
    removeCategoriesProductDetail,
    editCategoriesProductDetail,
    addCategoriesProductDetail,
    fetchCategoriesProductDetailByIdPaketDetil
  };

};
